import {
  Component,
  OnInit,
  HostListener,
  DestroyRef,
  inject,
} from "@angular/core";
import { MessageService } from "primeng/api";
import { SessionService } from "./session.service";
import { UserManagementService } from "./user-management/user-management.service";
import { PermissionService } from "./report-system/core/services/permission.service";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NotificationsService } from './notifications/notifications.service';
import { SiteMixedDashboardService } from './site-mixed-dashboard/site-mixed-dashboard.service';
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.css"],
  standalone: false,
})
export class AppComponent implements OnInit {
  constructor(
    
    private messageService: MessageService,
    
    private sessionService: SessionService,
    
    private userService: UserManagementService,
    private permissionService: PermissionService
  ,
    private notificationService: NotificationsService,
    private siteMixedDashboardService: SiteMixedDashboardService
  ) {
    // this.startTimer();
    // Initialize notification service with site mixed dashboard service for polling
    this.notificationService.setSiteMixedDashboardService(this.siteMixedDashboardService);
  }
  private intervalId: any;
  timeLeft: number = 60; // 1 minute timer
  interval: any;
  isSubmitDisabled: boolean = true;
  private destroyRef: DestroyRef = inject(DestroyRef);
  ngOnInit(): void {
    this.sessionService.startSessionTimeout();

    if (this.userService.hasValidAuthSession()) {
      this.fetchPermissions();
    }
  }
  // Listen to various user activity events to reset session timeout
  @HostListener("window:mousemove")
  @HostListener('window:mousedown')
  @HostListener("window:keydown")
  @HostListener('window:keypress')
  @HostListener('window:click')
  @HostListener('window:scroll')
  @HostListener('window:touchstart')
  @HostListener('window:touchmove')
  resetSessionTimeout(): void {
    this.sessionService.resetSessionTimeout();
  }

  private fetchPermissions(): void {
    this.permissionService
      .loadPermissions()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: () => {},
        error: (error) => {
          console.error("Failed to load permissions:", error);
        },
      });
  }
  // startTimer() {
  //   const user = this.userService.getUserDetail();
  //   if (user?.id) {
  //   this.timeLeft = 60; // Reset the timer
  //   this.interval = setInterval(() => {
  //     if (this.timeLeft > 0) {
  //       this.timeLeft--;
  //     } else {
  //       this.timeLeft = 60;
  //        const request={
  //         user_id:user?.id
  //       }
  //       this.userService.isUserAvailable(request).then((response: any) => {
  //         if (response && response.session_token) {
  //           if(user.session_token!=response.session_token){
  //             this.sessionService.autologoutTimeout();
  //           }else{

  //           }
  //         }
  //         })
  //     }
  //   }, 1000);
  // }
  // }
}
